// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__cXGAT","title":"card_title__uXWzQ","subtitle":"card_subtitle__SHW8r","close":"card_close__3lLx9","textButton":"card_textButton__N7_Oe","body":"card_body__B5qdc"};